import store from "..";
import * as actions from "../Actions/complaint";
export const setComplaintData = (data) => {
  store.dispatch(actions.setComplaintData(data));
};

export const resetComplaintData = () => {
  store.dispatch(actions.resetComplaintData());
};
